<template>
  <div
    class="common-chip"
    :class="[size, color, filled ? 'filled' : '', transparent ? 'transparent' : '']"
  >
    <slot v-if="!empty" />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    filled?: boolean
    transparent?: boolean
    color?: ApplicationColors
    size?: 'xsmall' | 'small' | 'medium' | 'large'
    empty?: boolean
  }>(),
  {
    color: 'primary',
    size: 'small'
  }
)
</script>

<style scoped lang="scss">
.common-chip {
  display: block;
  width: fit-content;
  border-radius: 100px;
  border: 1px solid;
  background-color: transparent;
}

.xsmall {
  font-size: 11px;
  padding: 2px 8px;
}

.small {
  padding: 3px 10px;
  font-size: 14px;
}

.medium {
  padding: 5px 10px;
  font-size: 16px;
}

.large {
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 500;
}

.filled {
  border: 0;
}

@mixin color($class: primary) {
  $background: var(--vc-#{$class});
  $background-rgb: var(--vcrgb-#{$class});

  .#{'' + $class} {
    color: $background;
    border-color: $background;
  }

  .#{'' + $class}.filled {
    background-color: $background;
    color: var(--vc-white);
  }

  .#{'' + $class}.transparent {
    background-color: rgba($background-rgb, 0.1);
    color: $background;
    border: 0;
  }
}

@include color();
@include color(dark);
@include color(success);
@include color(warning);
@include color(danger);
@include color(blue);
@include color(pink);
</style>
